import ActionLink from './ActionLink';
import CtaButtons from './CtaButtons';
import Footer from './Footer';
import Header from './Header';
import SectionContact from './SectionContact';
import SectionContent from './SectionContent';
import SectionCta from './SectionCta';
import SectionFaq from './SectionFaq';
import SectionFeatures from './SectionFeatures';
import SectionHero from './SectionHero';
import SectionPosts from './SectionPosts';
import SectionPricing from './SectionPricing';
import SectionReviews from './SectionReviews';
import SubscribeForm from './SubscribeForm';
import Layout from './Layout';

export {
    ActionLink,
    CtaButtons,
    Footer,
    Header,
    SectionContact,
    SectionContent,
    SectionCta,
    SectionFaq,
    SectionFeatures,
    SectionHero,
    SectionPosts,
    SectionPricing,
    SectionReviews,
    SubscribeForm,
    Layout
};

export default {
    ActionLink,
    CtaButtons,
    Footer,
    Header,
    SectionContact,
    SectionContent,
    SectionCta,
    SectionFaq,
    SectionFeatures,
    SectionHero,
    SectionPosts,
    SectionPricing,
    SectionReviews,
    SubscribeForm,
    Layout
};
